import React from "react";

const KnowledgeManagementContainer = () => {
  const iframe =
    '<iframe src="https://app.powerbi.com/reportEmbed?reportId=2091929f-de77-4f4d-bc13-1e95d7678cf5&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1mLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D%22" width="1000px" height="610px"></iframe>';

  return (
    <div>
      {/* <ContainerReports>
         <h1>KnowledgeManagementContainer</h1>
       <ContainerIframe
         contentEditable="true"
         dangerouslySetInnerHTML={{ __html: iframe }}
       ></ContainerIframe>
     </ContainerReports> */}
    </div>
  );
};

export default KnowledgeManagementContainer;
